type FormDataKeys = 'company' | 'username' | 'password';

const toggleLoginOverlay = () => {
  const loginOverlay = document.querySelector(
    '#comvis-login-overlay'
  ) as HTMLElement;

  loginOverlay.classList.toggle('comvis-login-overlay--open');

  if (loginOverlay.classList.contains('comvis-login-overlay--open')) {
    const params = new URLSearchParams(window.location.search);

    const redirect = params.get('redirect');

    const redirectField = document.querySelector(
      '#comvis-login-form-redirect'
    ) as HTMLInputElement;

    const companyField = document.querySelector(
      '#comvis-login-form-company'
    ) as HTMLInputElement;

    if (redirectField && redirect != null) {
      redirectField.value = redirect;
    }

    if (companyField) {
      companyField.focus();
    }
  }
};

export const watchFormFields = () => {
  const form = document.querySelector('#comvis-login-form') as HTMLFormElement;

  const submitButton = document.querySelector(
    '.comvis-login-form .comvis-login-form__submit'
  ) as HTMLButtonElement;

  const formData: Record<FormDataKeys, string> = {
    company: '',
    username: '',
    password: '',
  };

  const validateCompanyField = () => {
    return formData.company.trim().length > 0;
  };

  const isFormValid = () => validateCompanyField();

  const validateForm = () => {
    if (isFormValid()) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', '');
    }
  };

  form.addEventListener('input', (e) => {
    const { name, value } = e.target as HTMLInputElement;
    formData[name as FormDataKeys] = value;
    validateForm();
  });
};

export const watchHomeLoginButton = () => {
  const buttons = document.querySelectorAll('.comvis-login-overlay-toggle');

  buttons?.forEach((toggleButton) => {
    toggleButton.addEventListener('click', () => {
      toggleLoginOverlay();
    });
  });
};

export const watchUrlParameters = () => {
  const params = new URLSearchParams(window.location.search);

  const success = params.get('success');
  const company = params.get('company');
  const username = params.get('username');
  const message = params.get('message');

  if (success === 'false') {
    toggleLoginOverlay();

    const loginForm = document.querySelector(
      '#comvis-login-form'
    ) as HTMLFormElement;

    const companyField = loginForm?.querySelector(
      '#comvis-login-form-company'
    ) as HTMLInputElement;

    const usernameField = loginForm?.querySelector(
      '#comvis-login-form-username'
    ) as HTMLInputElement;

    const passwordField = loginForm?.querySelector(
      '#comvis-login-form-password'
    ) as HTMLInputElement;

    const errorField = document.querySelector(
      '#comvis-login-error-field-' + message
    ) as HTMLDivElement;

    if (companyField) {
      companyField.dataset.invalid = '';

      if (company) {
        companyField.value = company;
        companyField.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    if (usernameField) {
      usernameField.dataset.invalid = '';

      if (username) {
        usernameField.value = username;
        usernameField.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    if (passwordField) {
      passwordField.dataset.invalid = '';
      passwordField.focus();
    }

    if (message && errorField) {
      errorField.removeAttribute('hidden');
    }

    if (
      companyField?.value.length > 0 &&
      usernameField?.value.length > 0 &&
      passwordField?.value.length > 0
    ) {
      const submitButton = document.querySelector(
        '.comvis-login-form .comvis-login-form__submit'
      ) as HTMLButtonElement;

      submitButton.removeAttribute('disabled');
    }
  }
};

export const updateWebcatLinks = (): void => {
  const overlay = document.getElementById('comvis-login-overlay');

  if (!overlay) return;

  const currentHost = window.location.hostname;

  const domainMap: Record<string, string> = {
    'dev.comvis.eu': 'dev.webcat.lex-com.net',
    'qs.comvis.eu': 'qs.webcat.lex-com.net',
    'demo.comvis.eu': 'demo.webcat.lex-com.net',
  };

  const newDomain = domainMap[currentHost];

  if (!newDomain) return;

  const links = overlay.querySelectorAll<HTMLAnchorElement>(
    "a[href^='https://webcat.lex-com.net']"
  );

  links.forEach((link) => {
    const href = link.href;
    if (href.startsWith('https://webcat.lex-com.net')) {
      const updatedHref = href.replace('webcat.lex-com.net', newDomain);
      link.href = updatedHref;
    }
  });
};
